export default __webpack_public_path__ + "static/media/Eye_2_M_C1.4ef72f7b.svg";